export default __webpack_public_path__ + "static/media/longchamp34.fd21e075.jpg";